const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    disabled: false,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'hullNo',
    label: 'report.fields.hullNo',
    header: 'hullNo',
    filter: false,
    width: 20,
    disabled: false,
    formatter: (val) => {
      return val !== null ? val : '-'
    },
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'maxSpeed',
    label: 'report.fields.maxSpeed',
    header: 'maxSpeed',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'speedLimit',
    label: 'report.fields.speedLimit',
    header: 'speedLimit',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'startDate',
    label: 'report.fields.startTime',
    header: 'startTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'endDate',
    label: 'report.fields.endTime',
    header: 'stopTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'duration',
    label: 'report.fields.duration',
    header: 'duration',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'startLocation',
    label: 'report.fields.startLocation',
    header: 'startLocation',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'endLocation',
    label: 'report.fields.endLocation',
    header: 'stopLocation',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'distance',
    label: 'report.fields.distance',
    header: 'distance',
    filter: false,
    width: 20,
    disabled: false,
  },
]
export default fields
